import React from 'react';
import { Alert } from '@op/opds.opux';
import message from '../messages/Message';

const ErrorView = () => {
  return <Alert type="critical">{message('applicationErrorView_title')}</Alert>;
};

export default ErrorView;